import { render, staticRenderFns } from "./OwnerReservations.vue?vue&type=template&id=fbfb0dcc&scoped=true&"
import script from "./OwnerReservations.vue?vue&type=script&lang=js&"
export * from "./OwnerReservations.vue?vue&type=script&lang=js&"
import style0 from "./OwnerReservations.vue?vue&type=style&index=0&id=fbfb0dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfb0dcc",
  null
  
)

export default component.exports